<template>
  <ProgressBar v-if="isupload" class="mt-2 mb-2" :value="uploadprogress" style="height: 10px;font-size: 14px"></ProgressBar>
  <FileUpload v-if="showupload" :class="classupload" :fileLimit="1" :showUploadButton="false" :showCancelButton="false" :multiple="false" :chooseLabel="uploadLabel" @before-send="beforeUpload" name="fileupload" :url=urlupload :auto="true" accept="text/html" :maxFileSize="5000000" @progress="onProgress" @upload="onUpload" @select="onSelect"></FileUpload>
  <keterangan-form>Pilih berkas maksimum berukuran 1024kb. Hanya .html</keterangan-form>
  <div class="row">
    <div class="col-md-12">
      <Button @click="updateTemplateSurat">Update Template</Button>
      <ToggleSwitch class="ml-2" v-model="checked" /> View Tag
    </div>
  </div>
  <div class="row" v-show="checked">
    <div class="col-md-12 mb-2">
      <Chip v-for="(t,idx) in tag" :label="t" :key="idx" class="mt-2 mr-2 mb-1"/>
    </div>
  </div>
</template>

<script>
import FileUpload from "primevue/fileupload";
import ProgressBar from 'primevue/progressbar';
import DashboardServices from "@/services/dashboard.services";
import Button from 'primevue/button';
import Chip from 'primevue/chip';
import ToggleSwitch from 'primevue/toggleswitch';
export default {
  name: "PageUploadFileSurat",
  props: {
    data: undefined,
    tag: undefined
  },
  emits: ['update'],
  components:{FileUpload,ProgressBar,Button,Chip,ToggleSwitch},
  data:()=>({
    loading: false,
    response:'',
    checked: false,
    message:'',
    success: false,
    showupload: true,
    classupload:'',
    urlupload:'',
    uploadLabel:'',
    uploadmessage:"",
    uploadprogress:0,
    isupload: false,
    filelist:[],
  }),
  methods:{
    beforeUpload(request){
      let user = JSON.parse(localStorage.getItem('usergemala'));
      request.xhr.setRequestHeader('Authorization', 'Bearer ' + user.token);
      request.formData.append('paramname','jenissurat');
      request.formData.append('invid',this.data.id_jenis_surat);
      request.formData.append('paramvalue',this.data.jenis_surat);
      return request;
    },
    onProgress(event){
      this.isupload = true;
      this.uploadprogress = event.progress;
    },
    onUpload(event){
      let response = event.xhr.response;
      const obj = JSON.parse(response);
      this.uploadmessage = obj.data;
      let message = obj.message;
      if(obj.code===1){
        this.classupload='bg-success';
        this.$toast.add({ severity: 'success', summary: message, detail: 'File Uploaded', life: 3000 });
      }else{
        this.classupload='bg-danger';
        this.$toast.add({ severity: 'danger', summary: message, detail: 'File Uploaded', life: 3000 });
      }
      this.isupload1 = false;
    },
    onSelect(event){
      if(event.files.length >0){
        //this.uploadLabel1 = event.files[0].name;
      }
    },
    updateTemplateSurat(){
      let data = {
        data : this.data,
        file : this.uploadmessage
      }
      this.$emit('update', data)
    }
  },
  mounted() {
    let path = '/dashboard/uploadFileParameter';
    this.urlupload = DashboardServices.generateUrl(path);
  }
}
</script>

<style scoped>

</style>